import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { VSpacer, Checkbox, SearchInput, HSpacer } from 'sm-react-components';
import { getStorage } from '../../infrastructure/storageService';

import * as requests from '../../infrastructure/requests';
import {
    Typography,
    Grid,
    Hidden,
    FormControl,
    Select,
    MenuItem,
    ListItemText,
    Input
} from '@material-ui/core';
import PageContainer from '../container/PageContainer';
import RequestsList from '../components/RequestsList';
import RequestsMap from '../components/RequestsMap';
import RequestsInspector from '../components/RequestsInspector';
import RequestsMapPlaces from '../components/RequestsMapPlaces';

const styles = theme => ({
    noLogs: {
        padding: '10px'
    },
    content: {
        height: '300px'
    },
    listHeight: {
        [theme.breakpoints.up('md')]: {
            height: '540px'
        },
        [theme.breakpoints.down('sm')]: {
            height: '200px'
        }
    }
});

class Requests extends Component {
    state = {
        stats: undefined,
        startDateOffset: 3600,
        selectedLog: undefined,
        key: undefined,
        filters: {
            requests: ['optimizerV1', 'placesProfilerV1'],
            id: undefined,
            key: ''
        },
        keys: undefined,
        screenHeight: window.innerHeight
    };

    onRequestSelected = async key => {
        this.setState({ selectedLog: undefined }, async () => {
            try {
                const log = await requests.getExecution(key.id);
                this.setState({
                    key,
                    selected: { key, ...log },
                    selectedType: 'request',
                    selectedLog: log
                });
            } catch {
                this.setState({
                    key,
                    selected: { key },
                    selectedType: 'request',
                    selectedLog: undefined
                });
            }
        });
    };

    onPoiSelected = async poi => {
        this.setState({ selected: poi, selectedType: 'poi' });
    };

    onPlaceSelected = async place => {
        this.setState({ selected: place, selectedType: 'place' });
    };

    onRouteSelected = async route => {
        this.setState({ selected: route, selectedType: 'route' });
    };

    onRouteGPSSelected = route => {
        this.setState({ selected: route, selectedType: 'routeGPS' });
    };

    handleRequestsFilterUpdate = event => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                requests: event.target.value
            }
        });
    };

    handleKeysFilterUpdate = event => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                key: event.target.value
            }
        });
    };

    handleFilterTextUpdate = id => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                id
            }
        });
    };

    async componentDidMount() {
        const allKeys = await requests.getKeys();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        const key =
            getStorage('requestSelected') &&
            JSON.parse(getStorage('requestSelected'));
        if (key) {
            this.onRequestSelected(key);
        }
        this.setState({
            keys: allKeys.docs
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ screenHeight: window.innerHeight });
    };

    render() {
        const { classes } = this.props;
        const {
            selectedLog,
            selectedType,
            selected,
            key,
            filters,
            screenHeight,
            keys
        } = this.state;
        const mapKey = key ? 'map-' + key.id : 'map';
        return (
            <PageContainer className={classes.content}>
                <Hidden smDown>
                    <Grid container justify="space-between">
                        <Grid item>
                            <Typography variant={'h2'}>Requests</Typography>
                        </Grid>
                        <div className={classes.formControl}>
                            <FormControl>
                                <Select
                                    multiple
                                    value={filters.requests}
                                    onChange={this.handleRequestsFilterUpdate}
                                    input={<Input id="select-multiple-checkbox" />}
                                    style={{ minWidth: '200px' }}
                                    displayEmpty
                                    renderValue={selected => {
                                        if (selected.length === 0) {
                                            return (
                                                <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                    All requests
                                                </span>
                                            );
                                        }
                                        return selected.join(', ');
                                    }}
                                >
                                    {['optimizerV1', 'optimizerV1-get', 'placesProfilerV1'].map(
                                        request => (
                                            <MenuItem key={request} value={request}>
                                                <Checkbox
                                                    checked={filters.requests.indexOf(request) > -1}
                                                />
                                                <ListItemText primary={request} />
                                            </MenuItem>
                                        )
                                    )}
                                </Select>
                            </FormControl>
                            <FormControl>
                                <Select
                                    value={filters.key}
                                    onChange={this.handleKeysFilterUpdate}
                                    input={<Input id="select-multiple-checkbox-keys" />}
                                    style={{ minWidth: '200px', marginLeft: '20px' }}
                                    displayEmpty
                                    renderValue={selected => {
                                        if (selected === '') {
                                            return (
                                                <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                                                    All keys
                                                </span>
                                            );
                                        }
                                        return selected;
                                    }}
                                >
                                    <MenuItem key={'all'} value={''}>
                                        <Checkbox checked={filters.key === undefined} />
                                        <ListItemText primary={'All keys'} />
                                    </MenuItem>
                                    {keys &&
                                        keys.map(key => (
                                            <MenuItem key={key.id} value={key.id}>
                                                <Checkbox checked={key.id === filters.key} />
                                                <ListItemText primary={key.name} />
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>

                            <div style={{ display: 'inline-flex' }}>
                                <HSpacer />
                            </div>
                            <FormControl>
                                <SearchInput
                                    onTextChange={this.handleFilterTextUpdate}
                                    placeholder="Search by ID"
                                />
                            </FormControl>
                        </div>
                    </Grid>
                    <VSpacer medium />
                    <Grid container justify="space-between">
                        <RequestsInspector type={selectedType} data={selected} />
                    </Grid>
                </Hidden>

                <Grid container className={classes.listHeight}>
                    <Grid
                        item
                        md={4}
                        sm={12}
                        xs={12}
                        style={{ height: '100%', overflowY: 'auto' }}
                    >
                        <RequestsList
                            onRequestSelected={this.onRequestSelected}
                            filters={filters}
                        />
                    </Grid>
                    <Hidden smDown>
                        <Grid item xs={8}>
                            {key && key.request === 'placesProfilerV1' ? (
                                <RequestsMapPlaces
                                    key={mapKey}
                                    request={{ ...selected, ...selectedLog, key }}
                                    onPlaceSelected={this.onPlaceSelected}
                                    onRouteSelected={this.onRouteGPSSelected}
                                />
                            ) : (
                                <RequestsMap
                                    key={mapKey}
                                    request={{ ...selected, ...selectedLog, key }}
                                    onPoiSelected={this.onPoiSelected}
                                    onRouteSelected={this.onRouteSelected}
                                />
                            )}
                        </Grid>
                    </Hidden>
                </Grid>
                <Hidden mdUp xsDown>
                    <Grid item xs={12}>
                        {key && key.request === 'placesProfilerV1' ? (
                            <RequestsMapPlaces
                                key={mapKey}
                                height={screenHeight - 264}
                                request={{ ...selected, ...selectedLog, key }}
                                onPlaceSelected={this.onPlaceSelected}
                                onRouteSelected={this.onRouteGPSSelected}
                            />
                        ) : (
                            <RequestsMap
                                key={mapKey}
                                height={screenHeight - 264}
                                request={{ ...selected, ...selectedLog, key }}
                                onPoiSelected={this.onPoiSelected}
                                onRouteSelected={this.onRouteSelected}
                            />
                        )}
                    </Grid>
                </Hidden>
                <Hidden smUp>
                    <Grid item xs={12}>
                        {key && key.request === 'placesProfilerV1' ? (
                            <RequestsMapPlaces
                                key={mapKey}
                                height={screenHeight - 258}
                                request={{ ...selected, ...selectedLog, key }}
                                onPlaceSelected={this.onPlaceSelected}
                                onRouteSelected={this.onRouteGPSSelected}
                            />
                        ) : (
                            <RequestsMap
                                key={mapKey}
                                height={screenHeight - 258}
                                request={{ ...selected, ...selectedLog, key }}
                                onPoiSelected={this.onPoiSelected}
                                onRouteSelected={this.onRouteSelected}
                            />
                        )}
                    </Grid>
                </Hidden>
            </PageContainer>
        );
    }
}

export default withStyles(styles)(Requests);
